import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone, faColumns, faTimes } from "@fortawesome/free-solid-svg-icons";

library.add(faTimes, faPhone, faColumns);
